import React from 'react'
import styled from 'styled-components'

import { TableSortingDirection } from '.'

type Props = {
  activeDirection?: TableSortingDirection
}

export const SortIcon = ({ activeDirection }: Props): JSX.Element => {
  return (
    <Svg
      width='10'
      height='17'
      viewBox='0 0 10 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        opacity={activeDirection === 'ASC' ? '1' : '0.5'}
        d='M1 5L5 1L9 5'
        stroke='white'
        strokeLinecap='round'
      />
      <path
        opacity={activeDirection === 'DESC' ? '1' : '0.5'}
        d='M9 12L5 16L1 12'
        stroke='white'
        strokeLinecap='round'
      />
    </Svg>
  )
}

const Svg = styled.svg``
